import { render, staticRenderFns } from "./HzzpQuote.vue?vue&type=template&id=2d2cd6d7&scoped=true&"
import script from "./HzzpQuote.vue?vue&type=script&lang=js&"
export * from "./HzzpQuote.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./HzzpQuote.vue?vue&type=style&index=1&id=2d2cd6d7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2cd6d7",
  null
  
)

export default component.exports